// src/chartData.js

export const formatPeriod = (value) => {
  if (!value) return value;
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value));
  if (!match) return value;
  const [, year, month, day] = match;
  return `${month}-${day}-${year}`;
};

const rawData = {
  // ... (nessuna modifica qui)
  kpi: {
    roi: {
      evolution: {
        x: ["Gen", "Feb", "Mar", "Apr", "May", "Jun"],
        y: [45, 52, 35, 48, 55, 49],
      },
      minimum: {
        x: ["Gen", "Feb", "Mar", "Apr", "May", "Jun"],
        y: [40, 40, 40, 40, 40, 40],
      },
    },
    netMargin: {
      evolution: { x: ["Q1", "Q2", "Q3", "Q4"], y: [28, 22, 35, 33] },
    },
    grossMargin: {
      evolution: {
        x: ["Gen", "Feb", "Mar", "Apr", "May", "Jun"],
        y: [45, 48, 42, 55, 49, 51],
      },
    },
    budget: {
      evolution: {
        x: ["Gen", "Feb", "Mar", "Apr", "May", "Jun"],
        y: [800, 850, 920, 880, 950, 1000],
      },
      chartName: "cost",
    },
    serviceLevel: {
      evolution: {
        x: ["Gen", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"],
        y: [90, 88, 95, 85, 98, 92, 89, 94],
      },
      minimum: {
        x: ["Gen", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"],
        y: [90, 90, 90, 90, 90, 90, 90, 90],
      },
      chartName: "sl",
    },
    cost: {
      evolution: {
        x: ["Gen", "Feb", "Mar", "Apr", "May", "Jun"],
        y: [800, 850, 920, 880, 950, 1000],
      },
    },
    sl: {
      evolution: {
        x: ["Gen", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"],
        y: [90, 88, 95, 85, 98, 92, 89, 94],
      },
      minimum: {
        x: ["Gen", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"],
        y: [90, 90, 90, 90, 90, 90, 90, 90],
      },
    },
  },
  pie: {
    margin: {
      labels: [
        "IAE",
        "IAF",
        "IAG",
        "IAH",
        "LAE",
        "MAA",
        "MBA",
        "MBG",
        "SBA",
        "SEG",
        "SEU",
        "IAB",
      ],
      values: [12, 18, 11, 8, 14, 9, 7, 8, 5, 4, 3, 1],
    },
    cost: {
      labels: [
        "IAE",
        "IAF",
        "IAG",
        "IAH",
        "LAE",
        "MAA",
        "MBA",
        "MBG",
        "SBA",
        "SEG",
        "SEU",
        "IAB",
      ],
      values: [4, 4, 10, 10, 6, 9, 10, 7, 6, 12, 15, 7],
    },
  },
  forecast: {
    qty: {
      historical: {
        x: [5, 6, 7, 8, 9, 10],
        y: [627, 443, 1385, 874, 579, 768],
      },
      forecast_plus_sigma: {
        x: [5, 6, 7, 8, 9, 10],
        y: [825, 611, 1032, 970, 673, 793],
      },
      forecast_avg: {
        x: [5, 6, 7, 8, 9, 10],
        y: [773, 572, 956, 910, 605, 720],
      },
      forecast_minus_sigma: {
        x: [5, 6, 7, 8, 9, 10],
        y: [721, 533, 880, 850, 527, 647],
      },
    },
    value: {
      historical: {
        x: [5, 6, 7, 8, 9, 10],
        y: [163.02, 115.18, 360.1, 227.24, 150.54, 199.68],
      },
      forecast_plus_sigma: {
        x: [5, 6, 7, 8, 9, 10],
        y: [214.5, 158.86, 268.32, 252.2, 174.98, 206.18],
      },
      forecast_avg: {
        x: [5, 6, 7, 8, 9, 10],
        y: [200.98, 148.72, 248.56, 236.6, 157.3, 187.2],
      },
      forecast_minus_sigma: {
        x: [5, 6, 7, 8, 9, 10],
        y: [187.46, 138.58, 228.8, 221, 137.02, 168.22],
      },
    },
  },
};

const defaultChartColors = {
  kpi: {
    evolutionLine: { color: "#3498db", width: 2 },
    unconstrainedLine: { color: "#f39c12", width: 2 },
    minimumLine: { color: "#e74c3c", width: 2, dash: "dash" },
  },
  pie: {
    IAE: "#54a0ff",
    IAF: "#1dd1a1",
    IAG: "#ff9f43",
    IAH: "#ff6b6b",
    LAE: "#9b59b6",
    MAA: "#f1c40f",
    MBA: "#3498db",
    MBG: "#e84393",
    SBA: "#2ecc71",
    SEG: "#e67e22",
    SEU: "#48dbfb",
    IAB: "#95a5a6",
  },
};

export const getKpiChartConfig = (
  chartName,
  historyData,
  constraintsData, // Qui arriva familyDetails (struttura annidata) o globalConstraints (struttura piatta)
  isPopup = false,
  config = {},
  unconstrainedHistoryData = null
) => {
  let traces = [];
  const dataName = rawData.kpi[chartName]?.chartName || chartName;

  const evolutionLineStyle =
    config?.kpiChartColors?.evolutionLine ||
    defaultChartColors.kpi.evolutionLine;

  const unconstrainedLineStyle =
    config?.kpiChartColors?.unconstrainedLine ||
    defaultChartColors.kpi.unconstrainedLine;

  const minimumLineStyle =
    config?.kpiChartColors?.minimumLine || defaultChartColors.kpi.minimumLine;

  if (
    historyData &&
    historyData[dataName] &&
    Array.isArray(historyData[dataName]) &&
    historyData.runLabels
  ) {
    const hasUnconstrained =
      unconstrainedHistoryData &&
      unconstrainedHistoryData[dataName] &&
      Array.isArray(unconstrainedHistoryData[dataName]);

    const xLabels = historyData.runLabels.map(formatPeriod);

    const evolutionTrace = {
      x: xLabels,
      y: historyData[dataName],
      mode: "lines+markers",
      line: evolutionLineStyle,
      marker: { size: isPopup ? 6 : 4 },
      name: hasUnconstrained ? "Constrained" : "Current",
      connectgaps: true,
    };
    traces.push(evolutionTrace);

    if (hasUnconstrained) {
      traces.push({
        x: unconstrainedHistoryData.runLabels.map(formatPeriod),
        y: unconstrainedHistoryData[dataName],
        mode: "lines+markers",
        line: unconstrainedLineStyle,
        marker: { size: isPopup ? 6 : 4 },
        name: "Unconstrained",
        connectgaps: true,
      });
    }

    let minLineValue = null;
    let maxLineValue = null;

    // --- LOGICA ESTRAZIONE LIMITI ---

    // A. SERVICE LEVEL (SL)
    if (dataName === "sl") {
      // MODIFICA: Commentato per non mostrare la riga rossa del minimo
      /*
      if (
        constraintsData?.service_level &&
        typeof constraintsData.service_level.min_service_level === "number"
      ) {
        minLineValue = constraintsData.service_level.min_service_level;
      } else if (typeof constraintsData?.min_service_level === "number") {
        minLineValue = constraintsData.min_service_level;
      }
      */
    }
    // B. ROI
    else if (dataName === "roi") {
      if (
        constraintsData?.roi &&
        typeof constraintsData.roi.min_roi === "number"
      ) {
        // Struttura annidata (FamilyDetails): { roi: { min_roi: 0.25 } }
        minLineValue = constraintsData.roi.min_roi;
      } else if (typeof constraintsData?.min_roi === "number") {
        // Struttura piatta: { min_roi: 0.25 }
        minLineValue = constraintsData.min_roi;
      }
    }

    // C. PNA
    else if (dataName === "pna") {
      if (typeof constraintsData?.min_pna === "number") {
        minLineValue = constraintsData.min_pna;
      }
    }

    // D. SHELF INVENTORY
    else if (dataName === "shelfInventory") {
      if (
        typeof constraintsData?.max_shelf_inventory_value_growth === "number"
      ) {
        maxLineValue = constraintsData.max_shelf_inventory_value_growth;
      }
    }

    // E. BUDGET (COST)
    if (dataName === "cost") {
      // Nota: nel JSON FamilyDetails, max_budget è alla radice, non dentro cost
      if (typeof constraintsData?.max_budget === "number") {
        maxLineValue = constraintsData.max_budget;
      }
    }

    // --- AGGIUNTA TRACCE LIMITI ---

    // IMPORTANTE: Usiamo mode: "lines+markers" o i limiti non si vedono se c'è solo 1 punto di storia.
    // Usiamo symbol: "line-ew" o simile per simulare un trattino se è un punto solo, oppure marker piccoli.

    if (minLineValue !== null) {
      traces.push({
        x: xLabels,
        y: Array(historyData.runLabels.length).fill(minLineValue),
        mode: "lines", // Solo linea se abbiamo più punti
        line: minimumLineStyle,
        hoverinfo: "y",
        name: "Min Limit",
      });

      // Se abbiamo UN SOLO punto, aggiungiamo un marker per rendere visibile il limite
      if (historyData.runLabels.length === 1) {
        traces.push({
          x: xLabels,
          y: [minLineValue],
          mode: "markers",
          marker: {
            symbol: "line-ew-open",
            size: 20,
            color: minimumLineStyle.color,
            line: { width: 2 },
          },
          showlegend: false,
          hoverinfo: "skip",
        });
      }
    }

    if (maxLineValue !== null) {
      traces.push({
        x: xLabels,
        y: Array(historyData.runLabels.length).fill(maxLineValue),
        mode: "lines",
        line: minimumLineStyle,
        hoverinfo: "y",
        name: "Max Limit",
      });

      // Marker di fallback per grafico a 1 punto
      if (historyData.runLabels.length === 1) {
        traces.push({
          x: xLabels,
          y: [maxLineValue],
          mode: "markers",
          marker: {
            symbol: "line-ew-open",
            size: 20,
            color: minimumLineStyle.color,
            line: { width: 2 },
          },
          showlegend: false,
          hoverinfo: "skip",
        });
      }
    }
    // --- CALCOLO PADDING SUPERIORE ---
    let allValues = [...historyData[dataName]];
    if (hasUnconstrained) allValues.push(...unconstrainedHistoryData[dataName]);
    if (minLineValue !== null) allValues.push(minLineValue);
    if (maxLineValue !== null) allValues.push(maxLineValue);

    allValues = allValues.filter((v) => typeof v === "number");

    if (allValues.length > 0) {
      const maxY = Math.max(...allValues);
      const minY = Math.min(...allValues);
      const range = maxY - minY;

      // Calcola un valore "target" più alto.
      // Aggiungiamo il 20% del range totale
      const padding = range > 0 ? range * 0.2 : maxY !== 0 ? maxY * 0.2 : 10;
      const topBufferValue = maxY + padding;

      traces.push({
        x: [xLabels[0]],
        y: [topBufferValue],
        mode: "markers",
        marker: { opacity: 0, size: 0 },
        hoverinfo: "skip",
        showlegend: false,
      });
    }
  }

  // *** LOGICA DI FORMATTAZIONE ASSE Y ***
  let yAxisFormat = {};

  // Se è una percentuale (ROI o Service Level)
  if (
    ["roi", "sl", "serviceLevel", "pna", "shelfInventory"].includes(chartName)
  ) {
    yAxisFormat = { ticksuffix: "%" };
  }
  // Se è valuta (Margini o Budget/Cost)
  else if (["netMargin", "grossMargin", "budget", "cost"].includes(chartName)) {
    yAxisFormat = { tickprefix: "$" };
  }

  const hasUnconstrainedData = !!(unconstrainedHistoryData && unconstrainedHistoryData[dataName] && Array.isArray(unconstrainedHistoryData[dataName]));

  const baseLayout = {
    showlegend: hasUnconstrainedData,
    xaxis: {
      type: "category",
      showgrid: false,
      zeroline: false,
      tickfont: { color: "#555" },
      automargin: true,
      tickangle: -45,
    },
    yaxis: {
      gridcolor: "rgba(0, 0, 0, 0.1)",
      tickfont: { color: "#555" },
      ...yAxisFormat,
      nticks: 6,
    },
  };

  let layout, plotConfig;
  if (isPopup) {
    layout = {
      ...baseLayout,
      legend: hasUnconstrainedData ? {
        orientation: "h",
        yanchor: "top",
        y: -0.15,
        xanchor: "center",
        x: 0.5,
        font: { size: 11 },
      } : undefined,
      paper_bgcolor: "#FFFFFF",
      plot_bgcolor: "#FFFFFF",
      margin: { l: 50, r: 20, b: hasUnconstrainedData ? 60 : 30, t: 40 },
    };
    plotConfig = { responsive: true };
  } else {
    layout = {
      ...baseLayout,
      legend: hasUnconstrainedData ? {
        orientation: "h",
        yanchor: "top",
        y: -0.05,
        xanchor: "center",
        x: 0.5,
        font: { size: 9 },
      } : undefined,
      paper_bgcolor: "rgba(255, 255, 255, 0.9)",
      plot_bgcolor: "rgba(255, 255, 255, 0.0)",
      margin: { l: 15, r: 5, b: hasUnconstrainedData ? 20 : 2, t: 5 },

      xaxis: { ...baseLayout.xaxis, showticklabels: false },

      // Abilitiamo automargin sull'asse Y
      yaxis: {
        ...baseLayout.yaxis,
        showticklabels: true,
        automargin: true,
      },
    };
    plotConfig = { displayModeBar: true, responsive: true };
  }

  return { traces, layout, config: plotConfig };
};

// ***** PIE CHARTS *****
export const getPieChartConfig = (
  chartName,
  familyData,
  isPopup = false,
  config = {}
) => {
  // Se non ci sono dati, restituisci un grafico vuoto
  if (!familyData || familyData.length === 0) {
    return { traces: [], layout: {}, config: {} };
  }

  // ORDINAMENTO FISSO (Alfabetico per Family ID)
  const sortedData = [...familyData].sort((a, b) =>
    a.family.localeCompare(b.family)
  );

  let labels = [];
  let values = [];

  // Seleziona i dati corretti in base al nome del grafico usando i dati ORDINATI
  if (chartName === "margin") {
    labels = sortedData.map((family) => family.family);
    values = sortedData.map((family) => family.gross_margin);
  } else if (chartName === "cost") {
    labels = sortedData.map((family) => family.family);
    values = sortedData.map((family) => family.budget);
  }

  const pieSliceColors = config?.familyPieChartColors || defaultChartColors.pie;
  const sliceColors = labels.map((label) => pieSliceColors[label] || "#CCCCCC");

  const traces = [
    {
      type: "pie",
      labels: labels,
      values: values,
      hoverinfo: "label+percent",
      textinfo: isPopup ? "percent" : "label",
      textposition: "inside",
      insidetextorientation: "radial",
      domain: isPopup ? { x: [0, 0.8] } : undefined,

      // DISABILITA L'ORDINAMENTO AUTOMATICO DI PLOTLY
      sort: false,
      direction: "clockwise",
      rotation: 0,

      // Opzionale: Aggiunge un bordo bianco sottile tra le fette
      marker: {
        colors: sliceColors,
        line: {
          color: "#ffffff",
          width: 1,
        },
      },
    },
  ];

  let layout, plotConfig;
  if (isPopup) {
    layout = {
      paper_bgcolor: "#FFFFFF",
      plot_bgcolor: "#FFFFFF",
      showlegend: true,
      legend: { x: 0.82, font: { color: "#333" } },
      font: { color: "#333" },
      margin: { t: 60, b: 40, l: 40, r: 40 },
    };
    plotConfig = { displayModeBar: true, responsive: true };
  } else {
    layout = {
      paper_bgcolor: "rgba(0,0,0,0)",
      plot_bgcolor: "rgba(0,0,0,0)",
      showlegend: false,
      font: { color: "#ffffff" },
      margin: { t: 0, b: 0, l: 0, r: 0 },
      width: 230,
      height: 230,
    };
    plotConfig = { displayModeBar: false, responsive: true };
  }

  return { traces, layout, config: plotConfig };
};

/**
 * Funzione helper per estrarre le serie numeriche dai dati grezzi
 * Allinea i dati in base a un asse X di riferimento (o lo crea se non fornito)
 */
const processForecastSeries = (data, chartName, referenceXAxis = null) => {
  // 1. Filtra e ordina
  const forecastField = chartName === "qty" ? "fcst_qty_avg" : "fcst_val_avg";
  const sortedData = [...data]
    .filter(
      (row) => row[forecastField] !== null && row[forecastField] !== undefined
    )
    .sort((a, b) => a.year_week.localeCompare(b.year_week));

  if (sortedData.length === 0) return null;

  // Se non c'è un asse di riferimento, lo creiamo dai dati stessi
  const xAxis = referenceXAxis || sortedData.map((row) => row.year_week);

  // Creiamo una mappa per accesso veloce ai valori per data
  const dataMap = new Map();
  sortedData.forEach((row) => {
    dataMap.set(row.year_week, row);
  });

  const series = {
    x: xAxis,
    avg: [],
    plus: [],
    minus: [],
    historical: [],
    lastActualIndex: -1,
  };

  // Popoliamo gli array allineati all'asse X
  xAxis.forEach((key, index) => {
    const row = dataMap.get(key);

    if (!row) {
      // Se manca il dato per questa settimana, inseriamo null per interrompere la linea
      series.avg.push(null);
      series.plus.push(null);
      series.minus.push(null);
      series.historical.push(null);
      return;
    }

    // Estrazione Valori
    series.historical.push(
      chartName === "qty" ? row.actual_qty_last_year : row.actual_val_last_year
    );

    const currentActual = chartName === "qty" ? row.actual_qty : row.actual_val;
    const hasActual = currentActual !== null && currentActual !== undefined;

    if (hasActual) {
      series.avg.push(currentActual);
      series.plus.push(currentActual);
      series.minus.push(currentActual);
      series.lastActualIndex = index;
    } else {
      if (chartName === "qty") {
        series.avg.push(row.fcst_qty_avg);
        series.plus.push(row.fcst_qty_upperbound);
        series.minus.push(row.fcst_qty_lowerbound);
      } else {
        series.avg.push(row.fcst_val_avg);
        series.plus.push(row.fcst_val_upperbound);
        series.minus.push(row.fcst_val_lowerbound);
      }
    }
  });

  return series;
};

const NUMERIC_FORECAST_FIELDS = [
  "actual_qty",
  "actual_qty_last_year",
  "fcst_qty_lowerbound",
  "fcst_qty_avg",
  "fcst_qty_upperbound",
  "actual_val",
  "actual_val_last_year",
  "fcst_val_lowerbound",
  "fcst_val_avg",
  "fcst_val_upperbound",
];

const WINRATE_WEIGHT_PAIRS = [
  { wrField: "actual_wr_last_year", demandField: "actual_qty_last_year" },
  { wrField: "fcst_qty_lowerbound", demandField: "fcst_qty_lowerbound" },
  { wrField: "fcst_qty_avg", demandField: "fcst_qty_avg" },
  { wrField: "fcst_qty_upperbound", demandField: "fcst_qty_upperbound" },
];

export const aggregateWinrateByWeek = (wrData, demandData, customerType) => {
  if (!wrData || wrData.length === 0) return [];
  if (customerType !== "combined") {
    return wrData.filter((row) => row.customer_type === customerType);
  }

  // Backend now returns pre-aggregated "combined" rows — use them directly if present.
  const preCombined = wrData.filter((row) => row.customer_type === "combined");
  if (preCombined.length > 0) return preCombined;

  const demandByWeek = {};
  (demandData || []).forEach((row) => {
    const week = row.year_week;
    if (!demandByWeek[week]) demandByWeek[week] = {};
    demandByWeek[week][row.customer_type] = row;
  });

  const wrByWeek = {};
  wrData.forEach((row) => {
    const week = row.year_week;
    if (!wrByWeek[week]) wrByWeek[week] = {};
    wrByWeek[week][row.customer_type] = row;
  });

  return Object.keys(wrByWeek).map((week) => {
    const wrPrime = wrByWeek[week]["prime"];
    const wrRes = wrByWeek[week]["reseller"];
    const demPrime = (demandByWeek[week] || {})["prime"];
    const demRes = (demandByWeek[week] || {})["reseller"];

    const base = { ...(wrPrime || wrRes), year_week: week, customer_type: "combined" };

    WINRATE_WEIGHT_PAIRS.forEach(({ wrField, demandField }) => {
      const wrP = wrPrime?.[wrField] ?? null;
      const wrR = wrRes?.[wrField] ?? null;

      if (wrP == null && wrR == null) {
        base[wrField] = null;
      } else {
        const effectiveWrP = wrP ?? 0;
        const effectiveWrR = wrR ?? 0;
        const qtyP = wrP != null ? (demPrime?.[demandField] || 0) : 0;
        const qtyR = wrR != null ? (demRes?.[demandField] || 0) : 0;
        const totalQty = qtyP + qtyR;
        base[wrField] = totalQty > 0
          ? (effectiveWrP * qtyP + effectiveWrR * qtyR) / totalQty
          : (effectiveWrP || effectiveWrR);
      }
    });

    return base;
  });
};

export const aggregateByWeek = (data, customerType) => {
  if (!data || data.length === 0) return [];
  if (customerType !== "combined") {
    return data.filter((row) => row.customer_type === customerType);
  }

  // Backend now returns pre-aggregated "combined" rows — use them directly if present.
  const preCombined = data.filter((row) => row.customer_type === "combined");
  if (preCombined.length > 0) return preCombined;

  const weekMap = {};
  data.forEach((row) => {
    const week = row.year_week;
    if (!weekMap[week]) {
      weekMap[week] = { ...row, customer_type: "combined" };
      return;
    }
    NUMERIC_FORECAST_FIELDS.forEach((field) => {
      const existing = weekMap[week][field];
      const incoming = row[field];
      weekMap[week][field] = (existing != null || incoming != null)
        ? (existing || 0) + (incoming || 0)
        : null;
    });
  });
  return Object.values(weekMap);
};

export const getForecastChartConfig = (
  chartName,
  forecastApiData = [],
  isPopup = false,
  comparisonApiData = null // <--- NUOVO PARAMETRO
) => {
  // 1. Elabora la serie principale (Selected Generation)
  const mainSeries = processForecastSeries(forecastApiData, chartName);

  if (!mainSeries) {
    return { traces: [], layout: {}, config: {} };
  }

  const { x, avg, plus, minus, historical, lastActualIndex } = mainSeries;

  // 2. Elabora la serie di confronto (Current Generation) se presente
  // Usiamo l'asse X della serie principale come riferimento per allineare i dati
  let compSeries = null;
  if (comparisonApiData && comparisonApiData.length > 0) {
    compSeries = processForecastSeries(comparisonApiData, chartName, x);
  }

  const xLabels = x.map(formatPeriod);

  // --- COSTRUZIONE TRACCE ---
  const traces = [];

  // A. Tracce di CONFRONTO (Current) - Le disegniamo prima (sotto) o tratteggiate
  if (compSeries) {
    traces.push({
      x: xLabels,
      y: compSeries.avg,
      mode: "lines",
      name: "Current (Avg)",
      line: { color: "#3498db", width: 2, dash: "dot" }, // Blu tratteggiato
      marker: { opacity: 0 },
      opacity: 0.7,
    });
    traces.push({
      x: xLabels,
      y: compSeries.plus,
      mode: "lines",
      name: "Current (+σ)",
      line: { color: "#40c057", width: 1, dash: "dot" }, // Verde tratteggiato
      marker: { opacity: 0 },
      opacity: 0.7,
      showlegend: false,
    });
    traces.push({
      x: xLabels,
      y: compSeries.minus,
      mode: "lines",
      name: "Current (-σ)",
      line: { color: "#fa5252", width: 1, dash: "dot" }, // Rosso tratteggiato
      marker: { opacity: 0 },
      opacity: 0.7,
      showlegend: false,
    });
  }

  // B. Tracce PRINCIPALI (Selected)
  // 1. Confidence Area (Background)
  traces.push({
    x: xLabels,
    y: minus,
    mode: "lines",
    name: "Forecast -σ",
    line: { width: 0 },
    marker: { opacity: 0 },
    showlegend: false,
    hoverinfo: "skip",
  });
  traces.push({
    x: xLabels,
    y: plus,
    mode: "lines",
    name: "Confidence Area",
    line: { width: 0 },
    fill: "tonexty",
    fillcolor: "rgba(52, 152, 219, 0.15)", // Azzurro chiaro trasparente
    showlegend: false,
    hoverinfo: "skip",
  });

  // 2. Linee Solide
  traces.push({
    x: xLabels,
    y: minus,
    mode: "lines+markers",
    name: "Forecast -σ",
    line: { color: "#fa5252", width: 2 }, // Rosso
    marker: { size: isPopup ? 6 : 4, color: "#fa5252" },
  });
  traces.push({
    x: xLabels,
    y: plus,
    mode: "lines+markers",
    name: "Forecast +σ",
    line: { color: "#40c057", width: 2 }, // Verde
    marker: { size: isPopup ? 6 : 4, color: "#40c057" },
  });
  traces.push({
    x: xLabels,
    y: historical,
    mode: "lines+markers",
    name: "Actual Y-1",
    line: { color: "#95a5a6", width: 2 }, // Grigio
    marker: { size: isPopup ? 6 : 4, symbol: "diamond", color: "#95a5a6" },
  });
  traces.push({
    x: xLabels,
    y: avg,
    mode: "lines+markers",
    name: "Forecast (avg)",
    line: { color: "#3498db", width: 3 }, // Blu Sfumatura principale
    marker: { size: isPopup ? 7 : 5, color: "#3498db" },
  });

  // --- LAYOUT & SHAPES ---
  const dynamicShapes = [];
  const dynamicAnnotations = [];

  if (lastActualIndex > -1) {
    // Shape Today
    dynamicShapes.push({
      type: "line",
      x0: lastActualIndex,
      y0: 0,
      x1: lastActualIndex,
      y1: 1,
      yref: "paper",
      line: { width: 2, dash: "dash", color: "#ccc" },
    });
    dynamicAnnotations.push({
      x: lastActualIndex,
      y: -0.15,
      xref: "x",
      yref: "paper",
      text: "today",
      showarrow: false,
      font: { size: 12, color: "#ccc" },
    });

    // Shape LT
    const ltIndex = lastActualIndex + 2;
    if (ltIndex < x.length) {
      dynamicShapes.push({
        type: "line",
        x0: ltIndex,
        y0: 0,
        x1: ltIndex,
        y1: 1,
        yref: "paper",
        line: { width: 2, dash: "dash", color: "#ccc" },
      });
      dynamicAnnotations.push({
        x: ltIndex,
        y: -0.15,
        xref: "x",
        yref: "paper",
        text: "LT",
        showarrow: false,
        font: { size: 12, color: "#ccc" },
      });
    }
  }

  const yAxisTitle = chartName === "qty" ? "QTY" : "VALUE";

  const baseLayout = {
    font: { color: isPopup ? "#333" : "#ecf0f1" },
    margin: isPopup
      ? { l: 60, r: 20, b: 61, t: 40 }
      : { l: 60, r: 20, b: 71, t: 20 },
    paper_bgcolor: isPopup ? "#ffffff" : "#2c3e50",
    plot_bgcolor: isPopup ? "#ffffff" : "#2c3e50",
    showlegend: isPopup,
    legend: { orientation: "h", y: -0.2 },
    dragmode: isPopup ? "zoom" : false,
    hovermode: "closest",
    yaxis: {
      title: { text: yAxisTitle },
      gridcolor: isPopup ? "rgba(0,0,0,0.1)" : "rgba(255, 255, 255, 0.1)",
      zerolinecolor: isPopup ? "rgba(0,0,0,0.1)" : "rgba(255, 255, 255, 0.1)",
      showspikes: false,
    },
    xaxis: {
      type: "category",
      autorange: true,
      gridcolor: isPopup ? "rgba(0,0,0,0.1)" : "rgba(255, 255, 255, 0.1)",
      showticklabels: true,
      tickangle: -45,
      showspikes: false,
    },
    shapes: dynamicShapes,
    annotations: dynamicAnnotations,
  };

  return {
    traces,
    layout: baseLayout,
    config: { responsive: true, displayModeBar: true, doubleClick: "reset+autosize" },
  };
};

const processWinrateSeries = (data, referenceXAxis = null) => {
  const sortedData = [...data]
    .filter((row) => (row.fcst_qty_avg != null && row.fcst_qty_avg !== 0) || (row.actual_wr_last_year != null && row.actual_wr_last_year !== 0))
    .sort((a, b) => a.year_week.localeCompare(b.year_week));

  if (sortedData.length === 0) return null;

  const xAxis = referenceXAxis || sortedData.map((row) => row.year_week);

  const dataMap = new Map();
  sortedData.forEach((row) => {
    dataMap.set(row.year_week, row);
  });

  const series = {
    x: xAxis,
    actualRaw: [],
    fcstRaw: [],
    actualShrinked: [],
    fcstShrinked: [],
    lastActualIndex: -1,
  };

  const toPercent = (value) => (value != null ? value * 100 : null);

  xAxis.forEach((key, index) => {
    const row = dataMap.get(key);

    if (!row) {
      series.actualRaw.push(null);
      series.fcstRaw.push(null);
      series.actualShrinked.push(null);
      series.fcstShrinked.push(null);
      return;
    }

    series.actualRaw.push(toPercent(row.actual_wr_last_year));
    series.fcstRaw.push(toPercent(row.fcst_qty_avg));
    series.actualShrinked.push(toPercent(row.actual_wr_last_year_shrinked));
    series.fcstShrinked.push(toPercent(row.fcst_qty_avg_shrinked));

    if (row.actual_wr !== null && row.actual_wr !== undefined) {
      series.lastActualIndex = index;
    }
  });

  return series;
};

export const getWinrateChartConfig = (
  winrateApiData = [],
  isPopup = false,
  comparisonApiData = null
) => {
  const mainSeries = processWinrateSeries(winrateApiData);

  if (!mainSeries) {
    return { traces: [], layout: {}, config: {} };
  }

  const { x, actualRaw, fcstRaw, actualShrinked, fcstShrinked, lastActualIndex } =
    mainSeries;

  let compSeries = null;
  if (comparisonApiData && comparisonApiData.length > 0) {
    compSeries = processWinrateSeries(comparisonApiData, x);
  }

  const xLabels = x.map(formatPeriod);

  const traces = [];

  if (compSeries) {
    traces.push({
      x: xLabels,
      y: compSeries.actualRaw,
      mode: "lines",
      name: "Current (Act. Raw)",
      line: { color: "#5d6d7e", width: 2, dash: "dot" },
      marker: { opacity: 0 },
      opacity: 0.7,
    });
    traces.push({
      x: xLabels,
      y: compSeries.fcstRaw,
      mode: "lines",
      name: "Current (Fcst. Raw)",
      line: { color: "#1f618d", width: 2, dash: "dot" },
      marker: { opacity: 0 },
      opacity: 0.7,
    });
    traces.push({
      x: xLabels,
      y: compSeries.actualShrinked,
      mode: "lines",
      name: "Current (Act. Shrinked)",
      line: { color: "#95a5a6", width: 2, dash: "dot" },
      marker: { opacity: 0 },
      opacity: 0.7,
    });
    traces.push({
      x: xLabels,
      y: compSeries.fcstShrinked,
      mode: "lines",
      name: "Current (Fcst. Shrinked)",
      line: { color: "#3498db", width: 2, dash: "dot" },
      marker: { opacity: 0 },
      opacity: 0.7,
    });
  }

  traces.push({
    x: xLabels, y: actualRaw, mode: "lines+markers", name: "Act. Raw",
    line: { color: "#5d6d7e", width: 2 },
    marker: { size: isPopup ? 6 : 4, symbol: "diamond", color: "#5d6d7e" },
  });
  traces.push({
    x: xLabels, y: fcstRaw, mode: "lines+markers", name: "Fcst. Raw",
    line: { color: "#1f618d", width: 2 },
    marker: { size: isPopup ? 6 : 4, color: "#1f618d" },
  });
  traces.push({
    x: xLabels, y: actualShrinked, mode: "lines+markers", name: "Act. Shrinked",
    line: { color: "#95a5a6", width: 2 },
    marker: { size: isPopup ? 6 : 4, symbol: "diamond", color: "#95a5a6" },
  });
  traces.push({
    x: xLabels, y: fcstShrinked, mode: "lines+markers", name: "Fcst. Shrinked",
    line: { color: "#3498db", width: 3 },
    marker: { size: isPopup ? 7 : 5, color: "#3498db" },
  });

  const dynamicShapes = [];
  const dynamicAnnotations = [];

  if (lastActualIndex > -1) {
    dynamicShapes.push({
      type: "line", x0: lastActualIndex, y0: 0, x1: lastActualIndex, y1: 1,
      yref: "paper", line: { width: 2, dash: "dash", color: "#ccc" },
    });
    dynamicAnnotations.push({
      x: lastActualIndex, y: -0.15, xref: "x", yref: "paper",
      text: "today", showarrow: false, font: { size: 12, color: "#ccc" },
    });
  }

  const baseLayout = {
    autosize: true,
    font: { color: isPopup ? "#333" : "#ecf0f1" },
    margin: isPopup ? { l: 60, r: 20, b: 61, t: 40 } : { l: 60, r: 20, b: 71, t: 20 },
    paper_bgcolor: isPopup ? "#ffffff" : "#2c3e50",
    plot_bgcolor: isPopup ? "#ffffff" : "#2c3e50",
    showlegend: isPopup,
    legend: { orientation: "h", y: -0.2 },
    dragmode: isPopup ? "zoom" : false,
    hovermode: "closest",
    yaxis: {
      title: { text: "Win Rate %" },
      gridcolor: isPopup ? "rgba(0,0,0,0.1)" : "rgba(255, 255, 255, 0.1)",
      zerolinecolor: isPopup ? "rgba(0,0,0,0.1)" : "rgba(255, 255, 255, 0.1)",
      showspikes: false,
      autorange: true,
    },
    xaxis: {
      type: "category",
      autorange: true,
      gridcolor: isPopup ? "rgba(0,0,0,0.1)" : "rgba(255, 255, 255, 0.1)",
      showticklabels: true,
      tickangle: -45,
      showspikes: false,
    },
    shapes: dynamicShapes,
    annotations: dynamicAnnotations,
  };

  return {
    traces,
    layout: baseLayout,
    config: { responsive: true, displayModeBar: true, doubleClick: "reset+autosize" },
  };
};
